import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { LinkReadinessParams } from '@/types/api';

export function useLinkReadiness(params: LinkReadinessParams = {}) {
  return useQuery({
    queryKey: analyticsKeys.linkReadiness(params),
    queryFn: () => analyticsApi.linkReadiness(params),
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
    placeholderData: keepPreviousData,
  });
}
